'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:invoke:ready');
}

var env = require('./env.js');

var fnQueue = [];

document.addEventListener('HBNB:ready', function() {
    if (process.env.NODE_ENV !== 'production') {
        debug('fnQueue length = %s', fnQueue.length);
    }

    for (var i = 0, ii = fnQueue.length; i < ii; ++i) {
        fnQueue[i]();
    }
});

var ready = function(fn) {
    if (typeof fn !== 'function') {
        return;
    }

    if (env.HBNBReady) {
        fn();
    } else {
        if (process.env.NODE_ENV !== 'production') {
            debug('push fn to fnQueue');
        }

        fnQueue.push(fn);
    }
};

module.exports = ready;



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/invoke/ready.js
// module id = 597
// module chunks = 0